module.exports = __webpack_public_path__ + "assets/img/live.23348df9.png";